import { CTA, FeatureLedger, Hero, Intro } from "../components/Section";
import { WorkFeature } from "../components/WorkGallery";
import { projectTypes } from "../content/site";
import { workImageSets, workProjects } from "../content/workImages";

export function ProjectsPage() {
  return (
    <>
      <Hero
        images={workImageSets.projectsHero}
        title="Project support for commercial, industrial, and custom metalwork."
        copy="This page is prepared for future project content. For now, it outlines the kinds of work Metalworks & Design Group can support with detailing, fabrication, finishing, delivery, and installation coordination."
        primary={{ label: "Start a Project", href: "/contact" }}
        secondary={{ label: "View our Services", href: "/services" }}
      />
      <Intro
        title="Our Work"
        copy="These project categories are ready for approved case studies, photo galleries, or project summaries as more client content is prepared."
      />
      {workProjects.map((project) => (
        <WorkFeature key={project.id} project={project} />
      ))}
      <FeatureLedger items={projectTypes} staggered />
      <CTA
        title="Have a project that needs fabrication review?"
        copy="Send drawings, specifications, photos, or a short scope summary and we will help identify the next practical step."
        label="Send Details"
        href="/contact"
      />
    </>
  );
}
